"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerInformationToJSON = exports.CustomerInformationFromJSONTyped = exports.CustomerInformationFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CustomerInformationFromJSON(json) {
    return CustomerInformationFromJSONTyped(json, false);
}
exports.CustomerInformationFromJSON = CustomerInformationFromJSON;
function CustomerInformationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hashEmail': json['hashEmail'],
        'tmpLegacyHashEmail': !(0, runtime_1.exists)(json, 'tmpLegacyHashEmail') ? undefined : json['tmpLegacyHashEmail'],
        'reference': !(0, runtime_1.exists)(json, 'reference') ? undefined : json['reference'],
        'debitBalance': json['debitBalance'],
        'dunningThread': json['dunningThread'],
        'dunningLevel': json['dunningLevel'],
        'creditWorthiness': json['creditWorthiness'],
        'accountBlockSign': json['accountBlockSign'],
        'blockadeMessageId': json['blockadeMessageId'],
        'amountDue': json['amountDue'],
        'deathSign': !(0, runtime_1.exists)(json, 'deathSign') ? undefined : json['deathSign'],
        'visitor': (0, _1.CustomerInformationVisitorFromJSON)(json['visitor']),
        'newsletter': !(0, runtime_1.exists)(json, 'newsletter') ? undefined : json['newsletter'],
        'newsCount': !(0, runtime_1.exists)(json, 'newsCount') ? undefined : json['newsCount'],
    };
}
exports.CustomerInformationFromJSONTyped = CustomerInformationFromJSONTyped;
function CustomerInformationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hashEmail': value.hashEmail,
        'tmpLegacyHashEmail': value.tmpLegacyHashEmail,
        'reference': value.reference,
        'debitBalance': value.debitBalance,
        'dunningThread': value.dunningThread,
        'dunningLevel': value.dunningLevel,
        'creditWorthiness': value.creditWorthiness,
        'accountBlockSign': value.accountBlockSign,
        'blockadeMessageId': value.blockadeMessageId,
        'amountDue': value.amountDue,
        'deathSign': value.deathSign,
        'visitor': (0, _1.CustomerInformationVisitorToJSON)(value.visitor),
        'newsletter': value.newsletter,
        'newsCount': value.newsCount,
    };
}
exports.CustomerInformationToJSON = CustomerInformationToJSON;
//# sourceMappingURL=CustomerInformation.js.map